module.exports = __webpack_public_path__ + "media/images/iosh-494ffe96c281e2b11dcf1629b02b8a3f.svg";